const addDOMScript = function(id, src) {
    const relative = document.getElementsByTagName('script')[0];
    if (document.getElementById(id)) {
        return;
    }
    const tag = document.createElement('script');
    tag.id = id;
    tag.async = false;
    tag.src = src;
    relative.parentNode.insertBefore(tag, relative);
};

export default addDOMScript;
